import React, { useMemo } from 'react'
import NativeReviews from './NativeReviews'
import ThirdPartyReviews from './ThirdPartyReviews/ThirdPartyReviews'
import LeaveAReviewBanner from './LeaveAReviewBanner'
import Spacer from '../../atoms/Spacer/Spacer'
import { isNonEmptyArray } from '../../../utils/checks'
export default function CenterReviews({ nativeReviews, center }) {
  const nativeReviewsProps = {
    center,
    nativeReviews
  }

  return (
    <div id="center-reviews">
      {isNonEmptyArray(nativeReviews) ? (
        <NativeReviews {...nativeReviewsProps} />
      ) : null}
      <ThirdPartyReviews center={center} />
      <LeaveAReviewBanner
        title={center?.title}
        image={center?.featured_image}
      />
      <Spacer className="h-[64px]" />
    </div>
  )
}
